import RecursiveObjectDisplay from "DashboardManagementPlatform/Helper";
import React from "react";

export const DetailLogActovity = ({ data, excludeKeys }) => {
  const dataDetail = data?.activityData[0];
  // console.log(data, "dataa");
  //   const detailNewDetail = dataDetail?.oldValue[0];
  // console.log(dataDetail, "dataDetail");
  //   console.log(dataDetail?.oldValue[0], "newValue");
  //   console.log(dataDetail?.newValue, "dataDetail?.newValue");
  let objDataNew;
  let objDataOld;
  let AllData;
  if (data) {
    try {
      AllData = {
        // action: data?.action,
        table_name: data?.table_name,
        timestamp: data?.timestamp,
      };
    } catch (e) {
      AllData = { description: "Upss, Kami ada masalah" };
    }
  }
  if (dataDetail?.newValue) {
    try {
      objDataNew = dataDetail?.newValue;
    } catch (e) {
      objDataNew = { description: "Upss, Kami ada masalah" };
    }
  }
  if (dataDetail?.oldValue) {
    try {
      objDataOld = dataDetail?.oldValue;
    } catch (e) {
      objDataOld = { ddescription: "Upss, Kami ada masalah" };
    }
  }
  const isAction = [
    "SOFT_DELETE",
    "START",
    "DELETE",
    "CREATE",
    "UPLOAD",
    "CHECK",
    "REGISTER",
    "STOP",
    "LOGIN",
  ];
  const resultIsAction = isAction.includes(data?.action);
  console.log(objDataNew, "objDataNew");
  // user_password

  return (
    <div>
      <div className="p-4 rounded-md border shadow-sm bg-white max-w-full">
        <div className="flex flex-col gap-2">
          <div className="text-base sm:text-lg font-semibold">
            <span className="text-gray-600">Nama Pengguna:</span>{" "}
            <span className="text-black">{data?.user_name || "-"}</span>
          </div>
          <div className="text-base sm:text-lg font-semibold">
            <span className="text-gray-600">Menu:</span>{" "}
            <span className="text-black">{data?.title_menu || "-"}</span>
          </div>
          <div className="text-base sm:text-lg font-semibold">
            <span className="text-gray-600">Aktivitas:</span>{" "}
            <span className="text-black">
              {objDataNew?.user_password
                ? "Ubah Password"
                : data?.action || "-"}
            </span>
          </div>
        </div>
      </div>
      <div>
        {objDataNew?.user_password ? (
          <div className="flex flex-col md:flex-row ">
            {/* Old Data */}
            <div className="w-full md:w-1/2 p-4 border rounded shadow">
              <h2 className="text-lg font-semibold mb-2">Data Lama</h2>
              <div>Password : -</div>
            </div>

            {/* New Data */}
            <div className="w-full md:w-1/2 p-4 border rounded shadow">
              <h2 className="text-lg font-semibold mb-2">Data Baru</h2>
              <div>Password : -</div>
            </div>
          </div>
        ) : resultIsAction ? (
          <div className="text-base sm:text-lg font-semibolAld mt-5">
            <RecursiveObjectDisplay data={AllData} excludeKeys={excludeKeys} />
          </div>
        ) : (
          <div className="flex flex-col md:flex-row ">
            {/* Old Data */}
            <div className="w-full md:w-1/2 p-4 border rounded shadow">
              <h2 className="text-lg font-semibold mb-2">Data Lama</h2>
              <RecursiveObjectDisplay
                data={objDataOld}
                excludeKeys={excludeKeys}
              />
            </div>

            {/* New Data */}
            <div className="w-full md:w-1/2 p-4 border rounded shadow">
              <h2 className="text-lg font-semibold mb-2">Data Baru</h2>
              <RecursiveObjectDisplay
                data={objDataNew}
                excludeKeys={excludeKeys}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
